import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';
import { convertToFormData } from '@/utils/formHelper';

export const useOrganizationStore = defineStore('organization', () => {
    const all = ref(null);
    const locale = ref('en');

    const reset = () => {
        all.value = null;
    };

    const actions = {
        search: (params) => axios.get('/api/v1/organizations', { params }),

        storeOrganization: (params) => {
            if (params.logo) {
                const formData = convertToFormData(params, params.logo, 'logo');
                return axios.post('/api/v1/organizations', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
            }
            return axios.post('/api/v1/organizations', params);
        },

        updateOrganization: (params) => {
            if (params.logo) {
                const formData = convertToFormData(params, params.logo, 'logo');
                return axios.post('/api/v1/organizations/' + params.hash + '?_method=PATCH', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
            }
            return axios.patch('/api/v1/organizations/' + params.hash, params);
        },

        destroyOrganization: (params) => axios.delete('/api/v1/organizations/' + params.hash),
    };

    const setLocale = (option) => {
        locale.value = option;
        window.axios.post('/set-locale', { locale: option });
    };

    return {
        all,
        locale,
        setLocale,
        reset,
        ...actions,
    };
});
